export const types = {
    login: '[auth] login',
    logout: '[auth] logout ',

    eventAddNew:'[event] Start add new',
}